// extracted by mini-css-extract-plugin
export default {"expired__reports_wrapper":"expiredReports_expired__reports_wrapper__odI9F"};